<template>
  <div class="all-brand fl">
    <p class="title tc">
      {{TLang('所有产品分类','my')}}
    </p>

    <ul class="category-list">
      <li class="category-item category-chosen">
        <p class="category-name">
          {{TLang('生日汇精选品牌','my')}}
        </p>

        <ul class="brand-list clear">
          <li
            v-for="item in boutiqueBrandList"
            :key="item.brandId"
            class="brand-item half fl"
          >
            <router-link
              :to="{ name: 'newBrandDetail', params: { brandId: item.brandId } }"
            >
              {{ item.name }}
            </router-link>
          </li>
        </ul>
      </li>
    <!-- 已经修改新窗口 -->
      <li class="category-item category-birthday">
        <p class="category-name">
          {{TLang('生日汇商品分类','my')}}
        </p>

        <ul class="brand-list  clear">
          <li class="brand-item fl">
            <router-link :target="isFeishuOrDingding ? '_self' : '_blank'" to="/product/list?channelId=3&goodsType=0">
              {{TLang('蛋糕面包西饼','my')}}
            </router-link>
          </li>
          <li class="brand-item fl">
            <!-- <a
              :href="`/birthday/list/13?city=${$route.query.city}`"
            >电子抵用券</a> -->
            <router-link :target="isFeishuOrDingding ? '_self' : '_blank'"  to="/product/list?channelId=3&goodsType=1">
              {{TLang('电子抵用券','my')}}
            </router-link>
          </li>
        </ul>
      </li>
<!-- 已经修改新窗口 -->
      <li class="category-item category-hot">
        <p class="category-name">
          {{TLang('生日汇正在热销中','my')}}
        </p>

        <ul class="brand-list clear">
          <li
            v-if="virtualGoods.goodsName"
            class="brand-item fl"
          >
            <a
            :target="isFeishuOrDingding ? '_self' : '_blank'"
              :href="virtualGoods && virtualGoods.pcUrl?virtualGoods.pcUrl:
                `/birthday/goods/detail/${virtualGoods.goodsId}?city=${city_id}`
              "
            >{{ virtualGoods.goodsName }}</a>
          </li>
          <li
            v-if="realGoods.goodsName"
            class="brand-item fl"
          >
            <router-link
              :target="isFeishuOrDingding ? '_self' : '_blank'"
              :to="{
                name: 'product/detail',
                
                query: {
                  cid: realGoods.categoryId,
                  gid: realGoods.goodsId
                }
              }"
            >
              {{ realGoods.goodsName }}
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
export default {
  name: 'AllBrand',
  props: {
    boutiqueBrandList: {
      type: Array,
      default: () => [],
    },
    virtualGoods: {
      type: Object,
      default: () => {},
    },
    realGoods: {
      type: Object,
      default: () => {},
    },
  },
  data(){
    return {
      city_id: Cookies.get('address') && JSON.parse(Cookies.get('address') || '{}').cityId || 145,
    };
  },
};
</script>

<style lang="less" scoped>
.all-brand {
  width: 300px;
  background: #fff;
  height: 400px;
  .title {
    line-height: 44px;
    font-size: 16px;
    color: #fff;
    background: #1a4a9e;
  }
  .category-list {
    padding: 0 15px;
  }
  .category-item {
    padding: 16px 0 16px 36px;
    border-bottom: 1px solid #dedede;
    &.category-chosen {
      background: url(../../assets/images/birthday/birthday_chosen.png) 0 14px
        no-repeat;
      background-size: 26px 30px;
    }
    &.category-birthday {
      background: url(../../assets/images/birthday/birthday_category.png) 0 14px
        no-repeat;
      background-size: 26px 30px;
    }
    &.category-hot {
      background: url(../../assets/images/birthday/birthday_hot.png) 0 14px
        no-repeat;
      background-size: 26px 30px;
    }
    &:last-child {
      border: none;
    }
  }
  .category-name {
    font-size: 16px;
    color: #1a4a9e;
    margin-bottom: 9px;
    line-height: 18px;
    width: 100%;
  }
  .brand-item {
    width: 100%;
    &.half {
      width: 50%;
    }
    a {
      display: block;
      color: #999;
      line-height: 26px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      &:hover {
        color: #1a4a9e;
      }
    }
  }
}
</style>
